<label>{{ label }}</label>

<div class="photo-uploader">
  <div class="apercu" *ngIf="value">
    <video *ngIf="estVideo(value)" [src]="value" controls muted></video>
    <img *ngIf="!estVideo(value)" [src]="value" [alt]="label">
    <button type="button" class="btn-effacer" (click)="effacer()" [title]="'admin.photo.retirer' | traduire">✕</button>
  </div>
  <div class="apercu apercu-vide" *ngIf="!value">{{ 'admin.photo.aucune' | traduire }}</div>

  <div class="champs">
    <input type="text" [ngModel]="value" (ngModelChange)="onUrlModifiee($event)"
           name="url-{{label}}" [placeholder]="'https://... ' + ('admin.photo.placeholder' | traduire)">

    <label class="btn-import" [class.desactive]="enCours">
      {{ enCours ? ('admin.photo.importEnCours' | traduire) : ('📁 ' + ('admin.photo.importer' | traduire)) }}
      <input type="file" accept="image/*,video/*" (change)="onFichierSelectionne($event)" [disabled]="enCours">
    </label>
    <p class="astuce-format">Images (JPG, PNG, GIF, WEBP, 5 Mo max) ou vidéos (MP4, WEBM, MOV, AVI, 50 Mo max)</p>

    <p class="erreur" *ngIf="erreur">{{ erreur }}</p>
  </div>
</div>
